import { SearchField } from "@heroui/react";

interface RecipeSearchBarProps {
    value: string;
    onChange(value: string): void;
    onSubmit(value: string): void;
    onClear(): void;
}

export const RecipeSearchBar = ({ value, onChange, onSubmit, onClear }: RecipeSearchBarProps) => {
    return (
        <div className="w-full max-w-xl mx-auto">
            <SearchField
                aria-label="Search recipes"
                value={value}
                onChange={onChange}
                onClear={onClear}
                onSubmit={(submitted) => onSubmit(submitted.trim())}
                fullWidth
            >
                <SearchField.Group>
                    <SearchField.SearchIcon />
                    <SearchField.Input placeholder="Search recipes..." />
                    <SearchField.ClearButton />
                </SearchField.Group>
            </SearchField>
        </div>
    );
};
